export const themes = [ 
    {
        name: 'dark',
        colorWhite: "#fff",
        colorBlack: "#000",
        colorBg1: '#252525',
        colorBg2: '#181818',
        colorBlueLight: '#00ccff',
        colorPurple: '#9933ff',
        colorPurple2: '#6157ff',
        colorSalmon: '#ff6666',
        colorSalmon2: '#ff4d4d',
        colorBlue2: '#00e6cc',
        colorGreen: '#00ff99',
        colorGreen2: '#00cc66',
        colorYellow: '#fff35c',
        colorGrey: '#a6a6a6',
        colorGrey2: '#4a4a4a',
        colorGreyDark: '#555555',
    }
]